import { useEffect } from 'react';
import { useStore } from 'react-redux';
import { onMiraklConsentGranted } from '@noths/polaris-client-mirakl-tracking/browser';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { sendMiraklListingViewBeacon } from 'src/tracking/mirakl/sendMiraklListingViewBeacon';

/**
 * A new visitor's first listing page renders before they have answered the cookie banner, so its
 * server-side view is skipped. When they accept advertising cookies on this page, send that view.
 */
export const MiraklConsentViewBeacon = () => {
  const store = useStore<ReduxApplicationState>();

  useEffect(
    () => onMiraklConsentGranted(() => sendMiraklListingViewBeacon(store.getState())),
    [store],
  );

  return null;
};
